// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__1fGZF","sendOtp":"AuthorizeToLogin_sendOtp__2CZ7O"};